// extracted by mini-css-extract-plugin
export default {"overlay":"xy-z","bodyOpen":"yy-z","content":"zy-z","header":"Ay-z","close":"By-z","closeNoHeading":"Cy-z"};